import MobileButtons from './MobileButtons';

export default function index(props) {
  const {
    productData,
    setAddedToCart,
    showSizePopup,
    showNewDiaperVariantUx,
    userType,
    openChooseVariantPopup,
    showPrepaidXOff,
  } = props;

  return (
    <>
      <MobileButtons
        productData={productData}
        setAddedToCart={setAddedToCart}
        showSizePopup={showSizePopup}
        showNewDiaperVariantUx={showNewDiaperVariantUx}
        userType={userType}
        openChooseVariantPopup={openChooseVariantPopup}
        showPrepaidXOff={showPrepaidXOff}
      />
    </>
  );
}
